// @flow

import type { Capabilities } from '@zapier/data/src';

const getNounMeta = capabilityPoweredByNouns => {
  return capabilityPoweredByNouns && capabilityPoweredByNouns._meta
    ? {
        noun_id: capabilityPoweredByNouns._meta.noun_id,
        noun_name: capabilityPoweredByNouns._meta.noun_name,
        num_mapped_fields: capabilityPoweredByNouns._meta.num_mapped_fields,
      }
    : undefined;
};

const getTemplatesFromCapabilities = ({
  canOnlyBePoweredByNouns,
  capabilityPoweredByNouns,
  canZTPowerSimpleZap,
  capabilityPoweredByZT,
}) => {
  if (canOnlyBePoweredByNouns && capabilityPoweredByNouns) {
    return capabilityPoweredByNouns.nodes;
  }

  if (canZTPowerSimpleZap && capabilityPoweredByZT) {
    return capabilityPoweredByZT.nodes;
  }

  return undefined;
};

const formatDataFromCapabilities = (capabilities: Capabilities) => {
  if (capabilities.length === 0) {
    return {
      isSimpleZapCapable: false,
      isFromNouns: false,
      isFromZT: false,
      ztTitle: undefined,
      ztId: undefined,
      nounMeta: undefined,
    };
  }

  const capabilityPoweredByNouns = capabilities.find(
    c => c.capability.type === 'noun-field-map-szs'
  );
  const canNounsPowerSimpleZap = Boolean(capabilityPoweredByNouns);
  const capabilityPoweredByZT = capabilities.find(
    c => c.capability.type === 'zt-field-map-szs'
  );
  const canZTPowerSimpleZap = Boolean(capabilityPoweredByZT);

  const canOnlyBePoweredByNouns =
    !canZTPowerSimpleZap && canNounsPowerSimpleZap;

  return {
    isSimpleZapCapable: canNounsPowerSimpleZap || canZTPowerSimpleZap,
    isFromNouns: canOnlyBePoweredByNouns,
    nounMeta: getNounMeta(capabilityPoweredByNouns),
    isFromZT: canZTPowerSimpleZap,
    ztTitle: capabilityPoweredByZT
      ? capabilityPoweredByZT.capability.zt_title
      : undefined,
    ztId: capabilityPoweredByZT
      ? capabilityPoweredByZT.capability.zt_id
      : undefined,
    templates: getTemplatesFromCapabilities({
      canOnlyBePoweredByNouns,
      capabilityPoweredByNouns,
      canZTPowerSimpleZap,
      capabilityPoweredByZT,
    }),
  };
};

export default formatDataFromCapabilities;
